// Maps a Mapbox Search Box `/retrieve` feature into a flat object
// keyed by Stimulus target name. Missing properties become null;
// callers should skip writing nulls so they do not blank existing values.
export function mapRetrieveToFields(feature) {
  if (!feature) return {}

  const props = feature.properties || {}
  const ctx = props.context || {}
  const coords = (feature.geometry && feature.geometry.coordinates) || []

  return {
    name: props.name || null,
    address: extractStreetAddress(props),
    locality: (ctx.place && ctx.place.name) || null,
    region: (ctx.region && (ctx.region.region_code || ctx.region.name)) || null,
    postalCode: (ctx.postcode && ctx.postcode.name) || null,
    country: (ctx.country && (ctx.country.country_code_alpha_3 || ctx.country.country_code || ctx.country.name)) || null,
    latitude: Number.isFinite(coords[1]) ? coords[1] : null,
    longitude: Number.isFinite(coords[0]) ? coords[0] : null
  }
}

// Mapbox's `properties.address` is the street-level address when present
// (e.g., "9035 Village Dr"). When absent, `full_address` is a
// comma-delimited string starting with the street segment; we take the
// first segment so locality/region/postcode do not leak into the
// address field.
function extractStreetAddress(props) {
  if (props.address) return props.address
  if (props.full_address) {
    const first = props.full_address.split(',')[0]
    return first ? first.trim() : null
  }
  return null
}
